import { FC } from 'react';
import cn from 'classnames';
import { IndeterminateSpinner } from '@ebsco-ui/ebsco-ui';

import { ShapeWithClassName } from '@app/constants';

import './PageSpinner.scss';

export const PageSpinner: FC<ShapeWithClassName> = ({ className }) => {
  return (
    <div data-auto="spinner">
      <IndeterminateSpinner
        level="page"
        className={cn(className, 'page-spinner')}
      />
    </div>
  );
};
